import { render, staticRenderFns } from "./package-order-info.vue?vue&type=template&id=f426d02e&scoped=true&"
import script from "./package-order-info.vue?vue&type=script&lang=js&"
export * from "./package-order-info.vue?vue&type=script&lang=js&"
import style0 from "./package-order-info.vue?vue&type=style&index=0&id=f426d02e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f426d02e",
  null
  
)

export default component.exports